import React from "react";
import { getOmfsStyle } from "@/lib/omfsCategories";

/**
 * Colored chip for an OMFS category. Renders nothing when the category is
 * empty so we don't clutter rows for legacy cases.
 */
export default function OmfsCategoryChip({ category, size = "sm", testId }) {
  if (!category) return null;
  const s = getOmfsStyle(category);
  const pad = size === "xs" ? "px-2 py-0.5" : "px-2.5 py-1";
  const textSize = size === "xs" ? "text-[10px]" : "text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border ${s.bg} ${s.text} ${s.border} ${pad} ${textSize} font-medium whitespace-nowrap`}
      data-testid={testId || `omfs-chip-${category}`}
      title={category}
    >
      <span
        className={`inline-block w-1.5 h-1.5 rounded-full ${s.dot}`}
        aria-hidden="true"
      />
      {category}
    </span>
  );
}
